const allTopicsData = [
  {
    name: 'Wow Shop',
    path: '/wowshop',
  },
  {
    name: 'Gift Guide',
    path: '/home/holiday-gift-guide',
  },
  {
    name: 'PureWow100',
    path: '/fashion/purewow-100-guide',
  },
  {
    name: 'Weddings',
    path: 'weddings',
  },
  {
    name: 'Cultures',
    path: 'cultures',
  },
  {
    name: 'Money',
    path: 'money',
  },
  {
    name: 'Books',
    path: 'books',
  },
  {
    name: 'Tech',
    path: 'tech',
  },
  {
    name: 'New York',
    path: 'ny',
  },
  {
    name: 'Los Angeles',
    path: 'la',
  },
  {
    name: 'Miami',
    path: 'miami',
  },
  {
    name: 'Dallas',
   path: 'dallas',
  },
  {
    name: 'Hamptons',
    path: 'hamptons',
  },
  {
    name: 'Chicago',
    path: 'chicago',
  }
];

export default allTopicsData;
